import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ServiceCard = ({ icon, title, description }) => (
  <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow text-center">
    <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center mx-auto mb-4 text-rose-gold">
      <SafeIcon icon={icon} className="text-3xl" />
    </div>
    <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
    <p className="text-gray-600 text-sm">{description}</p>
  </div>
);

const Services = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">Who Needs Ear Wax Removal?</h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <ServiceCard 
            icon={FiIcons.FiHeadphones}
            title="Headphone Users"
            description="Regular use of headphones or earbuds can push wax deeper into the canal, causing impaction."
          />
          <ServiceCard 
            icon={FiIcons.FiVolume2}
            title="Ear Defender Wearers"
            description="Occupational use of ear protection prevents natural wax migration, leading to build-up."
          />
          <ServiceCard 
            icon={FiIcons.FiActivity}
            title="Pre-Hearing Test"
            description="Clear ears are essential for accurate hearing tests. We prepare your ears for optimal results."
          />
        </div>
      </div>
    </section>
  );
};

export default Services;